const NS = 'ProgressBarWidget';
const CLS = 'progressBarWidget';

let _isInteger = require('lodash/isInteger');
import { easeInOutCubic } from 'easing-utils';

export class ProgressBarWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$tooltip = this.$element.find(`.${CLS}-tooltip`);
		this.$progressFill = this.$element.find(`.${CLS}-fill`);
		let value = parseFloat(this.$element.attr('data-percentage')) || 0;
		let displayTooltip = this.$element.attr('data-display-tooltip') === 'false' ? false : true;
		this.maxPercentage = 100;
		this.animationFrameCount = 60;
		this.animationFrameId;
		this.isAnimating = false;

		if(value < 0 || value > this.maxPercentage) {
			value = 0;
			console.error(`${NS}::Error`, 'Please supply a valid range between 0–100');
		}

        this.percentage = value;
        this.renderBar(value);

		if(displayTooltip) {
			this.$element.find('[data-toggle="tooltip"]').tooltip({
				delay: {
					show: 100,
					hide: 100
				},
				offset: '0, 3',
				placement: 'top'
			});

			this.$element.hover(() => {
				let tooltip = this.$tooltip.tooltip('show');
				$(tooltip.data('bs.tooltip').tip).addClass(`${CLS}-tooltip`);
				this.$element.addClass(`${CLS}--active`);
			}, () => {
				this.$element.removeClass(`${CLS}--active`);
				this.$tooltip.tooltip('hide');
			});
		}

		this.$element.on(`${CLS}.update`, _.throttle((event, params) => {
			let toPercentage = params && _isInteger(params.percentage) ? params.percentage : null;
			if(toPercentage !== null) {
				if(toPercentage >= 0 && toPercentage <= this.maxPercentage) {
					this.update(this.percentage, toPercentage, params.animate);
				}
				else {
					console.error(`${NS}::Error`, 'Please supply a valid range between 0–100');
				}
			}
			else {
				console.error(`${NS}::Error`, 'Please supply a valid integer value');
			}
		}, 500, { trailing: true }));
	}

    update(fromPercentage, toPercentage, animate = true) {
        if(animate && fromPercentage !== toPercentage) {
            this.animateBar(fromPercentage, toPercentage);
        }
        else {
            this.percentage = toPercentage;
            this.renderBar(toPercentage);
        }
	}

	/**
	 * Animates the bar (clears previous animation and starts a new when called rapidly)
	 * @param fromPercentage
	 * @param toPercentage
	 */
	animateBar(fromPercentage, toPercentage) {
		if(!this.isAnimating) {
			this.isAnimating = true;
			let shouldIncrement = fromPercentage < toPercentage;
			let range = Math.abs(fromPercentage - toPercentage); // Percentage range between currentPercentage and the percentage to set to

			let elapsedAnimationFrame = 0;

			let animate = () => {
				let easing = easeInOutCubic(elapsedAnimationFrame / this.animationFrameCount); // Set Easing based on animation interval

				let animatingPercentage;
				if(shouldIncrement) {
					animatingPercentage = ((range * easing) + fromPercentage);
				}
				else {
					animatingPercentage = Math.abs(((range * easing) - fromPercentage));
				}

				this.renderBar(animatingPercentage);
				this.percentage = Math.round(animatingPercentage);

				// Animation has completed
				if(elapsedAnimationFrame >= this.animationFrameCount) {
					cancelAnimationFrame(this.animationFrameId);
					this.isAnimating = false;
					this.percentage = toPercentage;
				}
				else {
					requestAnimationFrame(animate);
				}
				elapsedAnimationFrame++;
			};
			this.animationFrameId = requestAnimationFrame(animate);
		}
		else {
			if(this.animationFrameId) {
				cancelAnimationFrame(this.animationFrameId);
				this.isAnimating = false;
				this.animateBar(this.percentage, toPercentage);
			}
		}
	}

	renderBar(percentage) {
        this.$tooltip.attr('data-original-title', Math.round(percentage) + '%');
        let tooltipPosition = (Math.round(percentage) * 2) + '%';
        this.$tooltip.css('width', tooltipPosition);
        this.$progressFill.css('width', percentage + '%');
    }
}
